<div class="flex flex-col gap-4">
  @if (travellersLength() === 1) {
    <div class="w-full h-[1px] bg-surface-200"></div>

    <!--  If the itinerary is unchanged we only show the current itinerary (rendered normally)  -->
      <!--  If the itinerary is changed we render both original (rendered normally) and current (with change detection rendering)  -->
    @if (!!originalItineraryItems()) {
      <div class="w-[594px] justify-start text-text-color text-base font-semibold font-['Inter'] leading-5">Original Itinerary</div>
    } @else {
      <div class="justify-start text-text-color text-base font-semibold font-['Inter'] leading-5">Acquitted Itinerary</div>
    }
    <p-table [value]="originalItineraryItems() ?? currentItineraryItems()" [tableStyle]="{ 'min-width': '60rem' }" size="small" class="border-[1px] border-surface-400 rounded table-auto w-fit max-w-full">
      <ng-template #header>
        <tr class="text-surface-800 text-xs font-semibold font-['Roboto_Condensed']">
          <th class="rounded-tl" pTooltip="Personal Days">PD</th>
          <th>Date</th>
          <th class="grow">Location</th>
          <th>Time</th>
          <th>Location</th>
          <th>Time</th>
          <th>Work Type</th>
          <th>Breakfast</th>
          <th>Lunch</th>
          <th>Dinner</th>
          <th>Incidentals</th>
          <th>Catering</th>
          @if (showOverseasColumn()) {
            <th pTooltip="Overseas meals & incidentals">Overseas</th>
          }
          <th class="rounded-tr">Day Trip Rate</th>
        </tr>
      </ng-template>
      <ng-template #body let-itineraryItem let-rowIndex="rowIndex">
        @let dayOffClass = itineraryDayRowClass(originalItineraryItems() ?? currentItineraryItems(), rowIndex);
        <tr class="text-surface-800 text-xs font-['Roboto_Condensed']" [ngClass]="dayOffClass">
          <td [ngClass]="{'rounded-bl' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1)}">
            <p-check-box disabled inputId="personalDay1" [binary]="true" [ngModel]="itineraryItem.isPersonalDay"></p-check-box>
          </td>
          <td>
            <span>{{ itineraryItem.start | date:'dd/MM/yy' }}</span>
          </td>
          <td class="bg-primary-50">
            {{ taSubmissionDatasource.findLocation(itineraryItem.startLocationId, itineraryItem.startLocationNameId)?.name }}
          </td>
          <td class="bg-primary-50">
            <span>{{ itineraryItem.start | date:'HH:mm' }}</span>
          </td>
          <td class="bg-green-50">
            {{ taSubmissionDatasource.findLocation(itineraryItem.endLocationId, itineraryItem.endLocationNameId)?.name }}
          </td>
          <td class="bg-green-50">
            <span>{{ itineraryItem.end | date:'HH:mm' }}</span>
          </td>
          <td>
            {{ itineraryItem.workType}}
          </td>
          <td [ngClass]="{'text-surface-400' : (itineraryItem.breakfastValue === 0)}">
            {{ itineraryItem.breakfastValue | currency }}
          </td>
          <td [ngClass]="{'text-surface-400' : (itineraryItem.lunchValue === 0)}">
            {{ itineraryItem.lunchValue | currency }}
          </td>
          <td [ngClass]="{'text-surface-400' : (itineraryItem.dinnerValue === 0)}">
            {{ itineraryItem.dinnerValue | currency }}
          </td>
          <td [ngClass]="{'text-surface-400' : (itineraryItem.incidentalValue === 0)}">
            {{ itineraryItem.incidentalValue | currency }}
          </td>
          <td [ngClass]="{'text-surface-400' : (itineraryItem.cateringValue === 0)}">
            {{ itineraryItem.cateringValue | currency }}
          </td>
          @if (showOverseasColumn()) {
            <td [ngClass]="{'text-surface-400' : !itineraryItem.overseasValue}">
              {{ (itineraryItem.overseasValue ?? 0) | currency }}
            </td>
          }
          <td [ngClass]="{'rounded-br' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1), 'text-surface-400' : (itineraryItem.dayTripValue === 0), 'bg-purple-100' : (itineraryItem.dayTripValue > 0)}">
            {{ itineraryItem.dayTripValue | currency }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    @if (changeDetectionItems().length > 0) {
      <div class="w-full flex items-center gap-3">
        <div class="justify-start text-text-color text-base font-semibold font-['Inter'] leading-5">Acquitted Itinerary</div>
      </div>
      <p-table [value]="changeDetectionItems()" [tableStyle]="{ 'min-width': '60rem' }" size="small" class="border-[1px] border-surface-400 rounded table-auto w-fit max-w-full">
        <ng-template #header>
          <tr class="text-surface-800 text-xs font-semibold font-['Roboto_Condensed']">
            <th class="rounded-tl" pTooltip="Personal Days">PD</th>
            <th>Date</th>
            <th class="grow">Location</th>
            <th>Time</th>
            <th>Location</th>
            <th>Time</th>
            <th>Work Type</th>
            <th>Breakfast</th>
            <th>Lunch</th>
            <th>Dinner</th>
            <th>Incidentals</th>
            <th>Catering</th>
            @if (showOverseasColumn()) {
              <th pTooltip="Overseas meals & incidentals">Overseas</th>
            }
            <th class="rounded-tr">Day Trip Rate</th>
          </tr>
        </ng-template>
        <ng-template #body let-itineraryItem let-rowIndex="rowIndex">
          @let dayOffClass = itineraryDayRowClass(changeDetectionItems(), rowIndex);
          <tr class="text-xs font-['Roboto_Condensed']" [ngClass]="dayOffClass">
            <td [ngClass]="{'rounded-bl' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1)}" [style]="itineraryItem.fieldChanged['isPersonalDay']">
              <p-check-box disabled inputId="personalDay1" [binary]="true" [ngModel]="itineraryItem.isPersonalDay"></p-check-box>
            </td>
            <td [style]="(itineraryItem.dateChangedClass ?? '')">
              <span>{{ itineraryItem.start | date:'dd/MM/yy' }}</span>
            </td>
            <td [style]="itineraryItem.fieldChanged['startLocationNameId']" class='bg-primary-50'>
              {{ taSubmissionDatasource.findLocation(itineraryItem.startLocationId, itineraryItem.startLocationNameId)?.name }}
            </td>
            <td [style]="itineraryItem.fieldChanged['start']" class='bg-primary-50'>
              <span>{{ itineraryItem.start | date:'HH:mm' }}</span>
            </td>
            <td [style]="itineraryItem.fieldChanged['endLocationNameId']" class='bg-green-50'>
              {{ taSubmissionDatasource.findLocation(itineraryItem.endLocationId, itineraryItem.endLocationNameId)?.name }}
            </td>
            <td [style]="itineraryItem.fieldChanged['end']" class='bg-green-50'>
              <span>{{ itineraryItem.end | date:'HH:mm' }}</span>
            </td>
            <td [style]="itineraryItem.fieldChanged['workType']">
              {{ itineraryItem.workType}}
            </td>
            <td [style]="itineraryItem.fieldChanged['breakfastValue']" [ngClass]="{'text-surface-400' : (itineraryItem.breakfastValue === 0)}">
              {{ itineraryItem.breakfastValue | currency }}
            </td>
            <td [style]="itineraryItem.fieldChanged['lunchValue']" [ngClass]="{'text-surface-400' : (itineraryItem.lunchValue === 0)}">
              {{ itineraryItem.lunchValue | currency }}
            </td>
            <td [style]="itineraryItem.fieldChanged['dinnerValue']" [ngClass]="{'text-surface-400' : (itineraryItem.dinnerValue === 0)}">
              {{ itineraryItem.dinnerValue | currency  }}
            </td>
            <td [style]="itineraryItem.fieldChanged['incidentalValue']" [ngClass]="{'text-surface-400' : (itineraryItem.incidentalValue === 0)}">
              {{ itineraryItem.incidentalValue | currency }}
            </td>
            <td [style]="itineraryItem.fieldChanged['cateringValue']" [ngClass]="{'text-surface-400' : (itineraryItem.cateringValue === 0)}">
              {{ itineraryItem.cateringValue | currency  }}
            </td>
            @if (showOverseasColumn()) {
              <td [style]="itineraryItem.fieldChanged['overseasValue']" [ngClass]="{'text-surface-400' : !itineraryItem.overseasValue}">
                {{ (itineraryItem.overseasValue ?? 0) | currency }}
              </td>
            }
            <td [style]="itineraryItem.fieldChanged['dayTripValue']" [ngClass]="{'rounded-br' : (rowIndex === changeDetectionItems().length - 1), 'text-surface-400' : (itineraryItem.dayTripValue === 0), 'bg-purple-100' : (itineraryItem.dayTripValue > 0)}">
              {{ itineraryItem.dayTripValue | currency  }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    }

  } @else if (showTravellerPortions()) {
    <div class="grid grid-cols-2 w-fit gap-y-2 p-2">
      <div class="text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Traveller</b></div>
      <div class="text-text-color text-sm font-normal font-['Inter'] leading-5 justify-self-end"><b>Portion of Total TA Value</b></div>
      <div class="col-span-2 h-[1px] bg-surface-200 my-[2px]"></div>
      @for (traveller of this.taSubmission()?.travellers ?? []; track traveller) {
        <div class="text-text-color text-sm font-normal font-['Inter'] leading-5">{{traveller.details?.name}}</div>
        <div class="text-text-color text-sm font-normal font-['Inter'] leading-5 justify-self-end">{{(traveller.travellerId && (this.store.taValue()?.travellerAmounts ?? {})[traveller.travellerId] ?? 0 ) | currency}}</div>
        <div class="col-span-2 h-[1px] bg-surface-200 my-[1px]"></div>
      }
    </div>
  }
</div>
